if (document.getElementById('vue-dotation')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: [ '[[', ']]' ],
		mixins: [ baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin, MobileValidate ],
		el: '#vue-dotation',
		computed: {},
		data: {
			formDisabled: false,
			section: {
				endpoint: 'dotation',
				labelSubmit: 'Envoyer',
				title: 'Nous contacter',
				fields: {
					last_name: {
						label: 'Nom',
						component: 'input',
						model: {}
					},
					first_name: {
						label: 'Prénom',
						component: 'input',
						model: {}
					},
					email: {
						label: 'Email',
						component: 'input',
						type: 'email',
						model: {},
						validate: 'required|email'
					},
					phone_number: {
						label: 'Téléphone mobile',
						component: 'input',
						type: 'tel',
						model: {},
						validate: 'required|phone'
					},
					message: {
						label: 'Message',
						component: 'textarea',
						model: {}
					}
				},
				config: {
					rows: [
						{
							cols: [
								{
									labelClasses: 'col-md-4 mt-10 mt-n-md',
									fieldClasses: 'col-md-8',
									fields: [ 'last_name', 'first_name' ]
								},
								{
									labelClasses: 'col-md-4 mt-10 mt-n-md',
									fieldClasses: 'col-md-8',
									fields: [ 'email', 'phone_number' ]
								}
							]
						},
						{
							cols: [
								{
									classes: 'col-form-large',
									labelClasses: 'col-md-2 mt-10 mt-20-md self-start',
									fieldClasses: 'col-md-10',
									fields: [ 'message' ]
								}
							]
						}
					]
				}
			}
		},
		created() {
			this.$validator.localize('fr');
			this.$validator.extend('phone', MobileValidate);
		},
		methods: {
			scroll(id) {
				let to = document.getElementById(id);
				// console.log(to);
				// let element = document.scrollingElement || document.documentElement;
				// let rect = to.getBoundingClientRect();
				VueScrollTo.setDefaults({
					container: 'body',
					duration: 600,
					easing: 'ease',
					offset: 0,
					force: true,
					cancelable: true,
					onStart: false,
					onDone: false,
					onCancel: false,
					x: false,
					y: true
				});
				VueScrollTo.scrollTo(to);
			},
			sendForm() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						let data = {};
						data.site_id = window.site_id;
						Object.keys(this.section.fields).forEach((key) => {
							if (this.section.fields[key].component === 'select') {
								data[key] = this.section.fields[key].model.label;
							} else {
								data[key] = this.section.fields[key].model.value;
							}
						});
						this.post('contact-form', data)
							.then((response) => {
								this.formDisabled = true;
							})
							.catch((error) => {
								// console.log(error);
							});
					}
				});
			}
		}
	});
}
